import useRegistrarServiceRequests from '@hooks/queries/registry/onboarding/useRegistrarServiceRequests';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundRegistrarServiceRequests = () => {
  const { party } = useParties();
  const registrarRequests = useRegistrarServiceRequests();

  const filtered = registrarRequests.data?.filter((r) => r.payload.registrar === party) || [];
  return filtered || [];
};
